import React, { useContext } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from '../Home';
import About from '../About';
import HelpFAQ from '../HelpFAQ';
import Login from '../Login';
import Signup from '../Signup';
import { AuthContext } from '../AuthContext';
import { HOSPITAL_CLAIM_ENABLED } from '../featureFlags';
import UploadProcess from '../UploadProcess';
import UploadSuccess from '../UploadSuccess';
import BrowseVetBills from '../browseVetBills';
import Dashboard from '../Dashboard';
import Profile from '../Profile';
import Account from '../Account';
import VetHospitalDetail from '../VetHospitalDetail';
import Advice from '../Advice';
import AddPost from '../AddPost';
import PostDetails from '../PostDetails'; // Import PostDetail component
import BillDetail from '../BillDetail';
import PetDetail from '../PetDetail';
import PrivacyReviewEdit from '../PrivacyReviewEdit';
import Support from '../Support';
import AdminCorrections from '../AdminCorrections';
import AdminDashboard from '../AdminDashboard';
import AdminUsers from '../AdminUsers';
import AdminUploadModeration from '../AdminUploadModeration';
import AdminHospitalClaims from '../AdminHospitalClaims';
import HospitalClaim from '../HospitalClaim';
import ForgotPassword from '../ForgotPassword';
import ResetPassword from '../ResetPassword';
import PrivacyPolicy from '../PrivacyPolicy';
import TermsOfService from '../TermsOfService';

const RoutesConfig = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Or some kind of loading indicator
  }

  console.log('Current user:', user);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/help" element={<HelpFAQ />} />
      <Route path="/support" element={user ? <Support /> : <Navigate to="/login" state={{ from: location }} />} />
      <Route path="/browse" element={<BrowseVetBills />} />
      <Route path="/hospital/:hospitalName" element={<VetHospitalDetail />} /> {/* Add the new route */}
      <Route path="/hospital-claim" element={HOSPITAL_CLAIM_ENABLED ? <HospitalClaim /> : <Navigate to="/browse" replace />} />
      <Route path="/advice" element={<Advice />} />
      <Route path="/upload/*" element={user ? <UploadProcess /> : <Navigate to="/login" state={{ from: location }} />} />
      <Route path="/upload-success" element={user ? <UploadSuccess /> : <Navigate to="/login" state={{ from: location }} />} />
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/signup" element={user ? <Navigate to="/" /> : <Signup />} />
      <Route path="/forgot-password" element={user ? <Navigate to="/" /> : <ForgotPassword />} />
      <Route path="/reset-password/:token" element={user ? <Navigate to="/" /> : <ResetPassword />} />
      <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />} />
      <Route path="/pets/:petId" element={user ? <PetDetail /> : <Navigate to="/login" />} />
      {/* Bill detail is public — the API returns 404 for private uploads unless
          the viewer is the owner or an admin, so no client-side login wall. */}
      <Route path="/bills/:billId" element={<BillDetail />} />
      <Route path="/bills/:billId/privacy" element={user ? <PrivacyReviewEdit /> : <Navigate to="/login" />} />
      <Route path="/profile" element={user ? <Profile /> : <Navigate to="/login" />} />
      <Route path="/account" element={user ? <Account /> : <Navigate to="/login" />} />
      <Route path="/admin" element={user && user.role === 'admin' ? <AdminDashboard /> : <Navigate to="/login" />} />
      <Route path="/admin/users" element={user && user.role === 'admin' ? <AdminUsers /> : <Navigate to="/login" />} />
      <Route path="/admin/uploads" element={user && user.role === 'admin' ? <AdminUploadModeration /> : <Navigate to="/login" />} />
      <Route path="/admin/hospital-claims" element={HOSPITAL_CLAIM_ENABLED && user && user.role === 'admin' ? <AdminHospitalClaims /> : <Navigate to={user && user.role === 'admin' ? '/admin' : '/login'} replace />} />
      <Route path="/addpost" element={user && user.role === 'admin' ? <AddPost /> : <Navigate to="/login" />} />
      <Route path="/admin/corrections" element={user && user.role === 'admin' ? <AdminCorrections /> : <Navigate to="/login" />} />
      <Route path="/post/:postId" element={<PostDetails />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      
    </Routes>
  );
};

export default RoutesConfig;
